import { Tabs } from 'antd'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClinicMedical, faUser } from '@fortawesome/pro-solid-svg-icons'

import MaccsUsers from '../../../Components/shared/MaccsUsers'
import MaccsInstitution from '../../../Components/MACCS/Settings/Institution/MaccsInstitution'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

const { TabPane } = Tabs

const USER_TAB_NAME = 'Manage users'
const PARAMETERS_TAB_NAME = 'Institution parameters'
const TAB_STYLE = { marginTop: '3px' }

const MaccsInstitutionSettings = () => {
  const t = useSelector(selectTranslate)

  return (
    <Tabs defaultActiveKey='1' animated={false}>
      <TabPane
        key='1'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon icon={faUser} style={TAB_STYLE} />
            <div className='h-spacing' />
            {t(USER_TAB_NAME)}
          </div>
        }
      >
        <MaccsUsers />
      </TabPane>
      <TabPane
        key='2'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon
              icon={faClinicMedical}
              style={TAB_STYLE}
            />
            <div className='h-spacing' />
            {t(PARAMETERS_TAB_NAME)}
          </div>
        }
      >
        <MaccsInstitution />
      </TabPane>
    </Tabs>
  )
}

export default MaccsInstitutionSettings
